import { Fragment } from "react";

// Rendu du texte configuré côté admin : liens au format [libellé](url),
// saut de ligne simple = <br/>, ligne vide = nouveau paragraphe.
const LINK_REGEX = /\[([^\]]*)\]\(([^)\s]+)\)/g;

const isSafeUrl = (url) => /^(https?:|mailto:|tel:)/i.test(url);
const isExternalUrl = (url) => /^https?:/i.test(url);

const renderLine = (line, keyPrefix) => {
  const nodes = [];
  let lastIndex = 0;
  const regex = new RegExp(LINK_REGEX);
  let match;

  while ((match = regex.exec(line)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(line.slice(lastIndex, match.index));
    }

    const [raw, label, url] = match;
    if (isSafeUrl(url)) {
      nodes.push(
        <a
          key={`${keyPrefix}-a${match.index}`}
          href={url}
          {...(isExternalUrl(url)
            ? { target: "_blank", rel: "noopener noreferrer" }
            : {})}
        >
          {label}
        </a>
      );
    } else {
      nodes.push(raw);
    }

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < line.length) {
    nodes.push(line.slice(lastIndex));
  }

  return nodes;
};

const renderParagraph = (paragraph, pIndex) =>
  paragraph.split("\n").flatMap((line, lIndex) => {
    const parts = renderLine(line, `p${pIndex}-l${lIndex}`);
    return lIndex === 0
      ? parts
      : [<br key={`p${pIndex}-br${lIndex}`} />, ...parts];
  });

function RichText({ content }) {
  const paragraphs = String(content ?? "").split(/\n\s*\n/);

  return (
    <>
      {paragraphs.map((paragraph, index) =>
        index === 0 ? (
          <Fragment key={index}>{renderParagraph(paragraph, index)}</Fragment>
        ) : (
          <p key={index}>{renderParagraph(paragraph, index)}</p>
        )
      )}
    </>
  );
}

export default RichText;
